module.exports = __webpack_public_path__ + "static/media/Lord Milano Mockups.95cb96f8.svg";